import { useMemo } from 'react';
import { useFilteredList } from './useFilteredList';

function getValueByPath(obj: any, path: string) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
}

export function useFaultsData(faults: any[] | undefined) {
  const filteredFaults = useFilteredList(faults, [], (item, searchValue) => {
    const lowerSearch = searchValue.toLowerCase();

    // Check nested string fields
    const matchesStringField = ['location.asset_ui_name', 'fault_type.name'].some((key) => {
      const value = getValueByPath(item, key);
      return value && String(value).toLowerCase().includes(lowerSearch);
    });

    if (matchesStringField) return true;

    // Check work order references
    const workOrders = item.work_orders || [];
    return workOrders.some((wo: { wo_reference?: string }) => wo.wo_reference?.toLowerCase().includes(lowerSearch));
  });

  return filteredFaults;
}
